import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

const StaticLogo = ({ logo, visible, scene }) => {
  return (
    <CSSTransitionGroup
      transitionName='bo_logo'
      transitionEnterTimeout={500}
      transitionLeaveTimeout={0}
    >
      {visible && <div id={`${scene > 1 ? 'bo_splash__logo-' + scene : 'bo_splash__logo'}`} className={`bo_logo ${scene > 1 ? 'bo_splash__logo-' + scene : 'bo_splash__logo'}`} style={{ backgroundImage: `url(${logo})` }} key='logo' />}
    </CSSTransitionGroup>
  )
}

StaticLogo.propTypes = {
  logo: PropTypes.string,
  visible: PropTypes.bool,
  scene: PropTypes.number
}

export default StaticLogo



// WEBPACK FOOTER //
// ./src/templates/bouncy/components/fixed/StaticLogo.js